
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ErrorAlert extends Vue {
  @Prop({ required: true }) readonly message!: string;
  @Prop({ default: '' }) readonly details!: string;
  @Prop({ default: true }) readonly dismissible!: boolean;
  @Prop({ default: 0 }) readonly autoDismiss!: number; // seconds

  private visible = true;
  private dismissTimer: number | null = null;

  mounted(): void {
    if (this.autoDismiss > 0) {
      this.dismissTimer = window.setTimeout(() => {
        this.handleDismiss();
      }, this.autoDismiss * 1000);
    }
  }

  beforeDestroy(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
    }
  }

  handleDismiss(): void {
    this.visible = false;
    this.$emit('dismiss');

    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
    }
  }
}
